import { render, staticRenderFns } from "./order-filter.vue?vue&type=template&id=d87bab04&scoped=true&"
import script from "./order-filter.component.ts?vue&type=script&lang=ts&"
export * from "./order-filter.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-filter.scss?vue&type=style&index=0&id=d87bab04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87bab04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d87bab04')) {
      api.createRecord('d87bab04', component.options)
    } else {
      api.reload('d87bab04', component.options)
    }
    module.hot.accept("./order-filter.vue?vue&type=template&id=d87bab04&scoped=true&", function () {
      api.rerender('d87bab04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/components/order-filter/order-filter.vue"
export default component.exports